import { render, staticRenderFns } from "./jy-inventoryInfo.vue?vue&type=template&id=01b97982&scoped=true&"
import script from "./jy-inventoryInfo.vue?vue&type=script&lang=js&"
export * from "./jy-inventoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./jy-inventoryInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./jy-inventoryInfo.vue?vue&type=style&index=1&id=01b97982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b97982",
  null
  
)

export default component.exports